const saveExpirationDate = (key, duration) => {
  //key => CLE IN LOCALSTORAGE
  //duration => DUREE EXPIRATION EN HOUR
  const date = new Date()
  date.setTime(date.getTime() + duration * 60 * 60 * 1000)
  localStorage.setItem(key, date.valueOf())
}

export default saveExpirationDate
